(() => {
  const initialize = (root) => {
    if (!root || root.dataset.mtglInitialized === 'true') return;
    root.dataset.mtglInitialized = 'true';

    const items = root.querySelectorAll('[data-mtgl-reveal]');

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -24px' });

    items.forEach((item) => observer.observe(item));
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-mtgl]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
